import { Flex } from '@chakra-ui/react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { Header, Text } from '../../ui-components';

interface Props {
    id: string;
    currency: string;
    price: number;
    size?: 'heading' | 'base';
}

export const SalePrice: React.FC<Props> = ({ id, currency, price, size }: Props) => (
    <Flex data-testid={`${id}-product-sale-price`} className="space-x-1">
        {size === 'heading' ? (
            <>
                <Header
                    id={`${id}-product-sale-price-label`}
                    as="h4"
                    style="bold"
                    color="slt-red-error"
                    variant="header4"
                >
                    <FormattedMessage id="buy.box.sale" defaultMessage="Sale" />
                </Header>
                <Header
                    id={`${id}-product-sale-price-value`}
                    as="h4"
                    style="bold"
                    color="slt-red-error"
                    variant="header4"
                >
                    <FormattedNumber style="currency" currency={currency} value={price} />
                </Header>
            </>
        ) : (
            <>
                <Text id={`${id}-product-sale-price-label`} style="bold" color="slt-red-error">
                    <FormattedMessage id="buy.box.sale" defaultMessage="Sale" />
                </Text>
                <Text id={`${id}-product-sale-price-value`} style="bold" color="slt-red-error">
                    <FormattedNumber style="currency" currency={currency} value={price} />
                </Text>
            </>
        )}
    </Flex>
);

SalePrice.defaultProps = {
    size: 'heading',
};
